import React from 'react';
import './Loader.scss';

const Loader = () => <div className="loader" />;

export default Loader;
